import CONFIG_JSON from "@storefront/config/local.json";
export default CONFIG_JSON;
